import { render, staticRenderFns } from "./AlterarPlano.vue?vue&type=template&id=8a707e24&"
import script from "./AlterarPlano.vue?vue&type=script&lang=js&"
export * from "./AlterarPlano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports